import React from "react";
import { AiOutlineLogout } from "react-icons/ai";
import { logout } from "./store/slices/adLoginSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function NavFA({ onViewChange }) {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const navbarBrandStyle = {
     fontFamily:  'Garamond, serif',
    fontSize: '1.75rem',
    color: '#1d1e1e',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
     
  };
   const navbarStyle = {
    minHeight: '60px', // default height (can be overridden via media query in CSS)
    display: 'flex',
    alignItems: 'center',
    paddingTop: '5px',
    paddingBottom: '5px',
  };
   const logoStyle = {
    height: 'auto',
    width: 'clamp(50px, 6vw, 60px)', // responsive logo size
   
  };
  const handleUsers = () => {
    onViewChange('users');
  };

  const handlePendingOrder = () => {
    onViewChange('pending');
  };

  const handleLogout = () => {
    const confirmLogout = window.confirm("Are you sure you want to log out?");
    if (confirmLogout) {
        // Navigate user to the home page ("/") and nullify the phone number state
        dispatch(logout());
        nav("/");
    }
  };

  const handleHome = () => {
    onViewChange('orders');
  }

  const handleCompleteOrders = () => {
    onViewChange('complete');
  }

  const handleProducts = () => {
    nav("/product");
  }

  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-light color border border-dark" style={navbarStyle}>
        <img src="/thedata/LogoTDRS.png" alt="Logo"   onClick={handleHome} style={logoStyle} />
        <h2 style={navbarBrandStyle} onClick={handleHome}>The Dry Fruit Shop</h2>

        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
          <div className="navbar-nav ml-auto">

          <button className="btn btn-outline-primary ml-3 mr-3 mt-2 mb-2 text-center btn-lg rounded-pill shadow" onClick={handleProducts} >
              Products
            </button>

            <button className="btn btn-outline-dark ml-3 mr-3 mt-2 mb-2 text-center btn-lg rounded-pill shadow" onClick={handleUsers}>
              User's
            </button>

            <button className="btn btn-outline-success ml-3 mr-3 mt-2 mb-2 text-center btn-lg rounded-pill shadow" onClick={handlePendingOrder}>
              Pending Orders
            </button>

            <button className="btn btn-outline-light ml-3 mr-3 mt-2 mb-2 text-center btn-lg rounded-pill shadow" onClick={handleCompleteOrders}>
              Complete Orders 
            </button> 

            <button className="btn btn-outline-danger ml-3 mr-3 mt-2 mb-2 text-center btn-lg rounded-pill shadow" onClick={handleLogout}>
              <AiOutlineLogout className="mb-1 mr-1" />Logout
            </button>
          </div>
        </div>
      </nav>
    </div>
  );
}
